import ApolloClient from 'apollo-boost';
import gql from 'graphql-tag';
import { constants } from '../constants';

const URL = constants.BASE_URL + '/graphql';

const instance = new ApolloClient({
    uri: URL,
    request: async (operation) => {
        // Card tokens are keyed by (carddetid, clientcardsrno) to avoid
        // cross-tab collisions when a recipient has multiple cards open.
        const { carddetid, clientcardsrno } = operation.variables || {};
        if (carddetid && clientcardsrno) {
            const token = sessionStorage.getItem(`card_token:${carddetid}:${clientcardsrno}`);
            if (token) {
                operation.setContext({
                    headers: {
                        'x-authorization': 'Bearer ' + token,
                    },
                });
            }
        }
    },
});

export default class ApolloClientService {
    _instance: any;

    constructor() {
        this._instance = instance;
    }

    handlException(ex: any) {
        if (ex.graphQLErrors && ex.graphQLErrors.length) {
            // let error = ex.graphQLErrors[0];
            if (ex.networkError) {
                console.log('network error', ex.networkError);
            }
        }
        return { status: 1 };
    }

    async orderBySender(clientordersrno: string) {
        try {
            console.log('orderBySender...');
            let data = await this._instance.query({
                query: gql`
                    query sender($clientordersrno: String!) {
                        sender(clientordersrno: $clientordersrno) {
                            orderno
                            orderdate
                            ordertotal
                            group {
                                groupId
                                groupname
                                grouplogo
                            }
                            merchant {
                                merchantId
                                merchantname
                            }
                            paymentdetails {
                                ipdpcnoquad
                                ipdpcamt
                                ipdstatus
                                ipdcctype
                                ipddate
                            }
                            lineitems {
                                carddetid
                                clientcardsrno
                                lineitemid
                                denomination
                                personalmessage
                                cardsenderinfo {
                                    sendername
                                    senderemail
                                }
                                cardrecipientinfo {
                                    recipientname
                                    recipientemail
                                }
                                cardimage
                                cleansedgcnumber
                                reissuecarddet {
                                    carddetid
                                    reissuedate
                                }
                                card {
                                    cardimagename
                                    url
                                }
                                retailerid
                                shipdate
                            }
                            customstyle
                            status
                        }
                    }
                `,
                variables: {
                    clientordersrno,
                },
                fetchPolicy: 'no-cache',
            });
            console.log('orderBySender...', data.data);
            return data.data ? data.data.sender : { status: 1 };
        } catch (ex) {
            console.log('errorrro', ex);
            return this.handlException(ex);
        }
    }

    async getBalance(clientcardsrno: String) {
        try {
            console.log('getBalance...');
            let data = await this._instance.query({
                query: gql`
                    query getBalance($clientcardsrno: String!) {
                        getBalance(clientcardsrno: $clientcardsrno) {
                            balance
                            status
                            message
                        }
                    }
                `,
                variables: {
                    clientcardsrno,
                },
                fetchPolicy: 'no-cache',
            });
            console.log('getBalance...', data.data);
            return data.data ? data.data.getBalance : { status: 1 };
        } catch (ex) {
            console.log('errorrro', ex);
            return this.handlException(ex);
        }
    }

    async cardByRecipient(clientcardsrno: string, carddetid: number) {
        try {
            console.log('cardByRecipient...');
            let data = await this._instance.query({
                query: gql`
                    query recipient($clientcardsrno: String!, $carddetid: Int!) {
                        recipient(clientcardsrno: $clientcardsrno, carddetid: $carddetid) {
                            carddetid
                            clientcardsrno
                            lineitemid
                            denomination
                            personalmessage
                            cardsenderinfo {
                                sendername
                                senderemail
                            }
                            cardrecipientinfo {
                                recipientname
                                recipientemail
                            }
                            cardimage
                            giftcardnumber
                            emailsent
                            group {
                                groupId
                                groupname
                                grouplogo
                            }
                            merchant {
                                merchantId
                                merchantname
                            }
                            card {
                                cardimagename
                                url
                            }
                            retailerid
                            customstyle
                            status
                        }
                    }
                `,
                variables: {
                    clientcardsrno,
                    carddetid,
                },
                fetchPolicy: 'no-cache',
            });
            console.log('cardByRecipient...', data.data);
            return data.data ? data.data.recipient : { status: 1 };
        } catch (ex) {
            console.log('errorrro', ex);
            return this.handlException(ex);
        }
    }

    async updateCardSchedule(clientcardsrno: string, carddetid: number, shipdate: number) {
        try {
            console.log('updateCardSchedule...');
            let data = await this._instance.mutate({
                mutation: gql`
                    mutation updateCardSchedule(
                        $clientcardsrno: String!
                        $carddetid: Int!
                        $shipdate: Float!
                    ) {
                        updateCardSchedule(
                            clientcardsrno: $clientcardsrno
                            carddetid: $carddetid
                            shipdate: $shipdate
                        ) {
                            status
                            message
                        }
                    }
                `,
                variables: {
                    clientcardsrno,
                    carddetid,
                    shipdate,
                },
                fetchPolicy: 'no-cache',
            });
            console.log('updateCardSchedule...', data.data);
            return data.data ? data.data.updateCardSchedule : { status: 1 };
        } catch (ex) {
            console.log('errorrro', ex);
            return this.handlException(ex);
        }
    }

    async claimCardAccess(clientcardsrno: string, carddetid: number, email: string) {
        try {
            let data = await this._instance.mutate({
                mutation: gql`
                    mutation claimCardAccess($clientcardsrno: String!, $carddetid: Int!, $email: String!) {
                        claimCardAccess(clientcardsrno: $clientcardsrno, carddetid: $carddetid, email: $email) {
                            token
                            status
                            message
                        }
                    }
                `,
                variables: {
                    clientcardsrno,
                    carddetid,
                    email,
                },
                fetchPolicy: 'no-cache',
            });
            // Do NOT log data.data here — the response contains the card-session JWT
            return data.data ? data.data.claimCardAccess : { status: 1 };
        } catch (ex) {
            return this.handlException(ex);
        }
    }

}
